import React, { useState } from "react";
import { MapContainer, TileLayer, Polyline } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import "./../styling/Calculator.css"

const GreatCircleRoute = () => {
  const [point1, setPoint1] = useState("");
  const [point2, setPoint2] = useState("");
  const [path, setPath] = useState([]);

  const calculateGreatCircle = () => {
    console.log("Point 1:", point1);
    console.log("Point 2:", point2);

    if (!point1 || !point2) {
      alert("Please enter both points");
      return;
    }

    const parseCoords = (input) => {
      const cleaned = input.replace(/[^\d.,\- ]/g, ""); // Remove unwanted characters
      const parts = cleaned.split(/[, ]+/).map(Number);
      return parts.length === 2 ? parts : null;
    };

    const coord1 = parseCoords(point1);
    const coord2 = parseCoords(point2);

    if (!coord1 || !coord2) {
      alert("Invalid input format! Use lat,long or space-separated format.");
      return;
    }

    const [lat1, lon1] = coord1;
    const [lat2, lon2] = coord2;

    // Generate intermediate points along the great circle route
    const generateGreatCirclePath = (lat1, lon1, lat2, lon2, steps = 100) => {
      const toRad = (deg) => (deg * Math.PI) / 180;
      const toDeg = (rad) => (rad * 180) / Math.PI;

      const d = Math.acos(
        Math.sin(toRad(lat1)) * Math.sin(toRad(lat2)) +
          Math.cos(toRad(lat1)) *
            Math.cos(toRad(lat2)) *
            Math.cos(toRad(lon2 - lon1))
      );

      let points = [];
      for (let i = 0; i <= steps; i++) {
        const f = i / steps;
        const A = Math.sin((1 - f) * d) / Math.sin(d);
        const B = Math.sin(f * d) / Math.sin(d);

        const x =
          A * Math.cos(toRad(lat1)) * Math.cos(toRad(lon1)) +
          B * Math.cos(toRad(lat2)) * Math.cos(toRad(lon2));

        const y =
          A * Math.cos(toRad(lat1)) * Math.sin(toRad(lon1)) +
          B * Math.cos(toRad(lat2)) * Math.sin(toRad(lon2));

        const z = A * Math.sin(toRad(lat1)) + B * Math.sin(toRad(lat2));

        const newLat = toDeg(Math.atan2(z, Math.sqrt(x * x + y * y)));
        const newLon = toDeg(Math.atan2(y, x));

        points.push([newLat, newLon]);
      }
      return points;
    };

    const route = generateGreatCirclePath(lat1, lon1, lat2, lon2);
    console.log("Generated Path:", route);

    if (route.length > 0) {
      setPath(route);
    } else {
      alert("No valid route generated.");
    }
  };
  console.log("path _>", path.length> 0 ? path[0]: ' no points')
  return (
    <div className="calculator-card">
      <h2>Great Circle Route Finder</h2>
      <p>Enter two geographic points to visualize the shortest path.</p>

      <input
        type="text"
        placeholder="Enter Point 1 (lat, long)"
        value={point1}
        onChange={(e) => setPoint1(e.target.value.trim())}
      />
      <input
        type="text"
        placeholder="Enter Point 2 (lat, long)"
        value={point2}
        onChange={(e) => setPoint2(e.target.value.trim())}
      />
      <button onClick={calculateGreatCircle}>Show Route</button>

      <MapContainer center={[20, 80]} zoom={3} className="map-container">
        <TileLayer
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          attribution="&copy; OpenStreetMap contributors"
        />
        {path.length > 0 && <Polyline positions={path} color="blue"  key={path.length}/>}
      </MapContainer>

      <div className="info-section">
  <h3>What is a Great Circle Route?</h3>
  <p>
    A great circle is the shortest path between two points on a sphere, which is commonly used 
    in **aviation and maritime navigation**.
  </p>
  <a href="https://en.wikipedia.org/wiki/Great-circle_distance" target="_blank" rel="noopener noreferrer">
    Learn more on Wikipedia
  </a>
</div>
    </div>
  );
};

export default GreatCircleRoute;